import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AuthenticationService } from "app/_services/authentication.service";
import { Router } from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (
            event.status == 200 &&
            !event.body.success &&
            event.body.expireToken
          ) {
            localStorage.removeItem("currentSmmAccount");
            localStorage.removeItem("currentSmmData");
            localStorage.removeItem("loginCAS");
            localStorage.removeItem("isLoggedIn");
            localStorage.removeItem("cachedurl");
            location.href = "/auth";
            // setTimeout(() => {
            // window.location.href = '/auth';
            // this.router.navigate(["/auth"]);
            // }, 2000);
          }
        }
        return event;
      })
    );
  }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_models/error.interceptor.ts